import { MetaConversation } from 'lib-shared-legacy-types';
import { connect } from 'react-redux';

import { appActions } from 'app/app.actions';
import { featureFlags } from 'utils/featureFlagging/featureFlags/featureFlags';
import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';

import { twilioActions } from '../../../../app/middleware/twilio/actions/twilioActions';
import * as conversationActions from '../../../conversation/actions/conversation';
import { notificationActions } from '../../../notifications/actions/notification';
import { addCallerActions } from '../../../shared/addCallerModal/actions/addCaller';
import { transferToAgentActions } from '../../../shared/transferToAgentModal/actions/transferToAgentModal';
import { transferToNumberActions } from '../../../shared/transferToNumberModal/actions/transferToNumberModal';
import { actions } from '../../../telephony/actions/telephony';
import Phone from '../components/Phone';

const { conversationClose } = conversationActions.actions;

const { notificationAdd } = notificationActions;
const mapStateToProps = (state: any, ownProps: any) => {
  const { warmTransferToQueue } = featureFlags.get(['warm-transfer-to-queue']);
  const isWarmTransferAvailable =
    warmTransferToQueue &&
    ownProps?.metaConversation?.conversation?.initial_channel === 'pstnphone';

  return {
    meta: state.telephony.meta,
    isOnTrial:
      typeof state.settings.organization.organization.trial_ended_at ===
      'string'
        ? false
        : true,
    isOnHold: state.telephony.isOnHold,
    isOnMute: state.telephony.isOnMute,
    canMakeOutBoundCall: ownProps.canMakeOutBoundCall,
    metaConversation: ownProps.metaConversation,
    isInternalCall: ownProps.isInternalCall,
    isWarmTransferAvailable,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    telephonySendDigits: (digit: string) =>
      dispatch(twilioActions.twilioSendDigits({ digit: digit })),

    telephonySetHold: bindActionToPromise(dispatch, actions.telephonySetHold),
    telephonySetMute: bindActionToPromise(dispatch, actions.telephonySetMute),

    conversationClose: bindActionToPromise(dispatch, conversationClose),

    notificationAdd: (payload: any) => dispatch(notificationAdd(payload)),

    transferToNumberModalOpen: (metaConversation: MetaConversation) =>
      dispatch(
        transferToNumberActions.transferToNumberModalOpen({
          metaConversation: metaConversation,
        }),
      ),

    transferToAgentModalOpen: (metaConversation: MetaConversation) =>
      dispatch(
        transferToAgentActions.transferToAgentModalOpen({
          metaConversation: metaConversation,
        }),
      ),

    transferToQueueModalOpen: (payload: {
      csid: number;
      isWarmTransferAvailable?: boolean;
    }) =>
      dispatch(
        appActions.showModal({
          modal: {
            type: 'app:conversationQueueTransfer',
            arg: {
              csid: payload.csid,
              isWarmTransferAvailable: payload.isWarmTransferAvailable,
            },
          },
        }),
      ),

    addCallerModalOpen: (metaConversation: MetaConversation) =>
      dispatch(
        addCallerActions.addCallerModalOpen({
          metaConversation: metaConversation,
        }),
      ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Phone);
